import React from "react";
import JobsListCardsSection from "./components/jobs-list-cards-section/JobsListCardsSection";
import JobsListSearchSection from "./components/jobs-list-search-section/JobsListSearchSection";
import CustomBackgroundJobsPage from "@/common/components/custom-background/jobs-list/CustomBackgroundJobsPage";

import styles from "./styles/JobsList.module.scss";

const JobsList = ({ jobsData, relatedJobs, customTitle, gtmKeyword }: any) => {
  return (
    <div className={styles.jobsListWrapper}>
      <JobsListCardsSection
        gtmKeyword={gtmKeyword}
        jobsData={jobsData?.data}
        customTitle={customTitle}
      />
      <JobsListSearchSection relatedJobs={relatedJobs} />
      <CustomBackgroundJobsPage />
    </div>
  );
};

export default JobsList;
